import { HeroBackgroundImage } from "../../../../modules/content/components/HeroBackgroundImage/HeroBackgroundImage";
import { HeroSplitImage } from "../../../../modules/content/components/HeroSplitImage/HeroSplitImage";
import type { IHeroBlockProps } from "./HeroBlock.props";

export const HeroBlock = (props: IHeroBlockProps) => {
  if (!props.image) return null;

  return (
    <section
      className={props.parentClass}
      data-spacing={props.spacing || undefined}
      id={props.anchorId || undefined}
    >
      {props.variant === "split-image" ? (
        <HeroSplitImage {...props} />
      ) : (
        <HeroBackgroundImage {...props} />
      )}
    </section>
  );
};

HeroBlock.displayName = "Block::HeroBlock";
